export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8381.eea04ea9.jpg";